import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-redux-multilingual';
import Page from '../../components/Page';
import { base } from '../../redux/thunk';
// import { useNavigate } from 'react-router-dom';
//Material
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined';
import {
  Avatar,
  Box,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import DefaultAvatar from '../../assets/defaultPostImg.jpg';
import BigSwitcher from '../../components/BigSwitcher';
import { LetsGoBtn, LetsGoBtn2, ToTopBtn } from '../../components/Buttons';
import ApiService from '../../helpers/apiHelper';
import {
  resetState,
  setIsOpenComplainModal,
  setIsOpenImageCropModal,
  setIsOpenPostModal,
  setIsOpenResendingModal,
  setIsOpenServiceModal,
  setIsOpenUserContactsModal,
  setIsOpenUserEditModal,
  setIsOpenUserReadersModal
} from '../../redux/mainReducer';
import '../MainPage/index.css';
import UserContactsModal from '../modals/UserContactsModal';
import UserEditModal from '../modals/UserEditModal';
import UserReadersModal from '../modals/UserReadersModal';

import { useSnackbar } from 'notistack';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Element } from 'react-scroll';
import PostCard from '../../components/PostCard';
import ServiceCard from '../../components/ServiceCard';
import { Spinner } from '../../components/Spinner';
import { AddCircle, MoreHoriz, Star } from '@mui/icons-material';

// import { Spinner } from '../../components/Spinner';

function UserPage(props) {
  const translate = useTranslate();
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [startWith, setStartWith] = useState(0);
  const [pageScroll, setPageScroll] = useState(0);
  const [loadMore, setLoadMore] = useState(false);
  const [contentMaxCount, setContentMaxCount] = useState(0);

  const apiUser = new ApiService('auth/user/page');
  const apiPosts = new ApiService('posts/post/userPost');
  const apiServices = new ApiService('posts/service/userServices');
  const apiAvatar = new ApiService('auth/add-photo');
  const apiAvatarDelete = new ApiService('auth/delete-photo');
  const apiSubscribe = new ApiService('auth/subscribe');
  const apiSubscribers = new ApiService('auth/get-subscribers');
  const apiSubscriptions = new ApiService('auth/get-subscriptions');
  const apiChats = new ApiService('notification/chats');
  const apiComplaint = new ApiService('auth/user/complaint-user');
  const apiActivateServices = new ApiService('posts/service/switch-activating-by-user-id');
  // const apiActivateServices = new ApiService('service/switch-activating-by-user-id');
  // const apiUser = new ApiService('/user/page');
  // const apiPosts = new ApiService('post/userPost');
  // const apiServices = new ApiService('service/userServices');
  // const apiAvatar = new ApiService('add-photo');
  // const apiAvatarDelete = new ApiService('delete-photo');
  // const apiSubscribe = new ApiService('subscribe');
  // const apiSubscribers = new ApiService('get-subscribers');
  // const apiSubscriptions = new ApiService('get-subscriptions');
  // const apiChats = new ApiService('chats');
  // const apiComplaint = new ApiService('/user/complaint-user');

  const apiMuteUser = new ApiService('auth/muted-users/add-muted-user');
  const apiUnmuteUser = new ApiService('auth/muted-users/remove-muted-user');

  const apiUnSubscribe = new ApiService('auth/unsubscribe');
  // const apiBU = new ApiService('/blocked-users');
  const apiBU = new ApiService('auth/blocked-users');

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [contentSwitched, setContentSwitched] = useState(false);

  const [imgs, setImgs] = useState([]);
  const [userSubscribers, setUserSubscribers] = useState([]);
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const [isSendDataRequest, setIsSendDataRequest] = useState(false);

  const [content, setContent] = useState([]);

  const isOpenUserEditModal = useSelector((state) => state.global.isOpenUserEditModal);
  const isOpenUserContactsModal = useSelector((state) => state.global.isOpenUserContactsModal);
  const isOpenUserReadersModal = useSelector((state) => state.global.isOpenUserReadersModal);

  const mutedUsers = useSelector((state) => state.global.mutedUsers);
  const [isLoading, setIsLoadiang] = useState(false);
  const [isLoadingUserData, setIsLoadiangUserData] = useState(false);
  const [existsInactive, setExistsInactive] = useState(false);
  // const [isCreatePost, setIsCreatePost] = useState(false);
  // const [params] = useSearchParams();
  // const navigate = useNavigate();
  // console.log(contentSwitched);
  // const testUsers = ['1', '2', '3'];
  // function getFileFromBase64(string64, fileName) {
  //   const trimmedString = string64.replace('dataimage/jpegbase64', '');
  //   const imageContent = atob(trimmedString);
  //   const buffer = new ArrayBuffer(imageContent.length);
  //   const view = new Uint8Array(buffer);

  //   for (let n = 0; n < imageContent.length; n++) {
  //     view[n] = imageContent.charCodeAt(n);
  //   }
  //   const type = 'image/jpeg';
  //   const blob = new Blob([buffer], { type });
  //   return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  // }
  const sendComplaint = (type, text) => {
    apiComplaint
      .updateDataID(userData?.id, {
        complaintType: type,
        complaintDescription: text.length !== 0 ? text : null
      })
      .then((res) => {
        dispatch(setIsOpenComplainModal({ isOpen: false, func: null }));
        enqueueSnackbar('Скаргу надіслано.', { variant: 'success' });
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталась помилка.', { variant: 'error' });
      });
  };
  const userDataSetter = () => {
    if (params.id !== props.userData.id) {
      setIsLoadiangUserData(true);

      apiUser
        .getItemById(params.id)
        .then((res) => {
          setUserData(res.result);
          setIsLoadiangUserData(false);
          apiSubscribers.getAll({ userId: res.result.id }).then((res) => {
            setUserSubscribers(res.result);
          });

          apiSubscriptions.getAll({ userId: res.result.id }).then((res) => {
            setUserSubscriptions(res.result);
          });

          if (res.result.photoUrl) {
            setImgs([res.result?.photoUrl]);
          }
        })
        .catch((error) => {
          if (error?.info?.user.includes(`User doesn't exists`)) {
            navigate(`/${props.language}/error`);
          }
          if (error?.result && error?.result.includes('cannot access page user with id')) {
            navigate(`/${props.language}/error`);
          }
          if (error === 'Акаунт заблоковано адміністратором!') {
            navigate(`/${props.language}/error`);
          }
          console.error(error.message);
        });
    } else {
      setUserData(props.userData);

      if (props.userData.photoUrl) {
        setImgs([props.userData?.photoUrl]);
      }
    }
  };
  useEffect(() => {
    userDataSetter();
    // eslint-disable-next-line
  }, []);
  const dataSetter = (contentSwitched) => {
    setContent([]);
    setIsLoadiang(true);
    if (!contentSwitched) {
      // setIsCreatePost(false);
      apiPosts
        .getItemById(params.id, {
          page: startWith > 0 ? 0 : startWith,
          size: startWith > 0 ? 8 * startWith + 8 : 8
        })
        .then((res) => {
          setContent(res.result);
          setContentMaxCount(res.count);

          setIsLoadiang(false);
        })
        .catch((error) => {
          console.error(error);
          setIsLoadiang(false);
        });
    } else {
      apiServices
        .getItemById(params.id, {
          page: startWith > 0 ? 0 : startWith,
          size: startWith > 0 ? 8 * startWith + 8 : 8
        })
        .then((res) => {
          setContent(res.result);
          setContentMaxCount(res.count);
          setExistsInactive(res.existsInactive);
          setIsLoadiang(false);
        })
        .catch((error) => {
          console.error(error);
          setIsLoadiang(false);
        });
    }
  };
  const handleLoadMore = () => {
    setLoadMore(true);

    if (contentSwitched) {
      apiServices
        .getItemById(params.id, { page: startWith + 1, size: 8 })
        .then((res) => {
          setContentMaxCount(res.count);
          setLoadMore(false);
          setContent([...content, ...res.result]);
          setStartWith(startWith + 1);
          setExistsInactive(res.existsInactive);
        })
        .catch((error) => console.error(error));
    } else {
      apiPosts
        .getItemById(params.id, { page: startWith + 1, size: 8 })
        .then((res) => {
          setContentMaxCount(res.count);
          setLoadMore(false);
          setContent([...content, ...res.result]);
          setStartWith(startWith + 1);
        })
        .catch((error) => console.error(error));
    }
  };
  const [bools, setBools] = useState([true, false]);

  // eslint-disable-next-line

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const type = searchParams.get('type');
    if (type === 'posts') {
      setContentSwitched(false);
      setBools([true, false]);
      dataSetter(false);
    } else {
      setContentSwitched(true);
      setBools([false, true]);
      dataSetter(true);
    }
    // eslint-disable-next-line
  }, [searchParams.get('type')]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    window.addEventListener('scroll', () => setPageScroll(window.scrollY));
    return () => {
      window.removeEventListener('scroll', () => setPageScroll(window.scrollY));
      dispatch(setIsOpenUserContactsModal(false));
      dispatch(setIsOpenUserReadersModal(false));
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Page
      title={translate('bonfair_myPage')}
      sx={{
        display: 'flex',
        marginTop: '150px',
        alignItems: 'center',
        flexDirection: 'column',
        height: 'max-content',
        padding: { xs: '0px 20px', sm: '0px 20px', md: '0px 50px', lg: '0px 100px' }
      }}
    >
      <Element name="topUserPage" />
      <Stack
        spacing={1}
        justifyContent="center"
        alignItems="center"
        sx={{
          maxWidth: '1440px',
          width: '100% !important'
        }}
      >
        <Grid
          container
          sx={{
            maxWidth: '1440px',
            width: '100% !important'
          }}
          spacing={3}
        >
          {/* {params.id !== props.userData.id && ( */}
          {/*<Grid*/}
          {/*  item*/}
          {/*  xs={12}*/}
          {/*  sx={{*/}
          {/*    display: 'flex',*/}
          {/*    justifyContent: 'flex-start'*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Typography*/}
          {/*    variant="subtitle"*/}
          {/*    sx={{*/}
          {/*      display: 'inline-flex',*/}
          {/*      cursor: 'pointer',*/}
          {/*      color: 'black',*/}
          {/*      ':hover': { color: '#60A5DF' }*/}
          {/*    }}*/}
          {/*    onClick={() => navigate(-1)}*/}
          {/*  >*/}
          {/*    <ReplyIcon sx={{ mr: 1, color: 'black' }} />*/}
          {/*    Повернутись на попередню сторінку*/}
          {/*  </Typography>*/}
          {/*</Grid>*/}
          {/* )} */}
          {/*<Grid item xs={4} />*/}
          <Grid
            // id="test"
            item
            xs={12}
            sm={12}
            lg={3}
            sx={{ p: '0px !important' }}
          >
            <Grid container spacing={params.id !== props.userData.id ? 0 : 4}>
              <Grid item xs={12} sm={params.id !== props.userData.id ? 12 : 6} lg={12}>
                <Paper
                  elevation={0}
                  sx={
                    userData && userData?.role !== 'PREMIUM_USER'
                      ? {
                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                          borderRadius: '8px',
                          padding: '16px',
                          marginBottom: { xs: '0px', sm: '50px', lg: '0px' },
                          maxWidth: '340px',
                          width: isLoadingUserData ? '340px !important' : 'unset',
                          minHeight: isLoadingUserData ? '340px' : 'unset',
                          display: isLoadingUserData ? 'flex' : 'block',
                          alignItems: isLoadingUserData ? 'center' : 'unset',
                          justifyContent: isLoadingUserData ? 'center' : 'unset',
                          position: 'relative',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                      : {
                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                          borderRadius: '8px',
                          border: '2px solid #E2F2FF',
                          padding: '16px',
                          maxWidth: '340px',
                          marginBottom: { xs: '0px', sm: '50px', lg: '0px' },
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          width: isLoadingUserData ? '340px !important' : 'unset',
                          minHeight: isLoadingUserData ? '340px' : 'unset',
                          display: isLoadingUserData ? 'flex' : 'block',
                          alignItems: isLoadingUserData ? 'center' : 'unset',
                          justifyContent: isLoadingUserData ? 'center' : 'unset',
                          position: 'relative'
                        }
                  }
                >
                  {props?.blockedUsers.find((user) => user?.id === userData?.id) ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 'calc(100% + 0px)',
                        height: 'calc(100% + 0px)',
                        position: 'absolute',
                        backgroundColor: 'rgba(124, 124, 124, 0.40)',
                        top: 0,
                        right: 0,
                        zIndex: 100,
                        borderRadius: '7px'
                      }}
                    >
                      <div
                        style={{
                          // position: 'absolute',
                          width: 'fit-content',
                          backgroundColor: '#FFE5E5',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                          fontFamily: 'FixelText-Medium',
                          fontWeight: '500',
                          color: '#F64D36',
                          fontSize: '20px'
                          // top: '4px',
                          // left: '4px'
                        }}
                      >
                        Ви заблокували користувача
                      </div>
                    </div>
                  ) : null}
                  <Grid
                    container
                    spacing={0}
                    sx={isLoadingUserData ? { marginLeft: '0px !important' } : {}}
                  >
                    {!isLoadingUserData ? (
                      <>
                        <Grid
                          item
                          xs={12}
                          flexDirection="row"
                          display="flex"
                          sx={{
                            position: 'relative',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            paddingTop:
                              userData && userData?.role === 'PREMIUM_USER'
                                ? '15px !important'
                                : '10px'
                          }}
                        >
                          {/*avatar*/}
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              flexWrap: 'wrap',
                              marginBottom: '20px'
                            }}
                          >
                            {imgs.length !== 0 ? (
                              imgs.map((file, index) => (
                                <div
                                  style={
                                    userData && userData?.role === 'PREMIUM_USER'
                                      ? {
                                          border: !props.blockedUsers.find(
                                            (el) => el.id === userData.id
                                          )
                                            ? '2px solid #E2F2FF'
                                            : '2px solid red',
                                          borderRadius: '80px',
                                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                                        }
                                      : {
                                          border: !props.blockedUsers.find(
                                            (el) => el.id === userData.id
                                          )
                                            ? '2px solid #F0F0F0'
                                            : '2px solid red',
                                          borderRadius: '80px',
                                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                                        }
                                  }
                                  key={'image' + index}
                                  className={
                                    params.id === props.userData.id
                                      ? `uploaded-avatar ${
                                          userData?.role === 'PREMIUM_USER' && 'premiumAvatar'
                                        }`
                                      : `${userData?.role === 'PREMIUM_USER' && 'premiumAvatar'}`
                                  }
                                  onClick={() => {
                                    if (params.id === props.userData.id) {
                                      apiAvatarDelete.deleteItemQuery().then((res) => {
                                        const newArray = imgs;
                                        newArray.splice(index, 1);
                                        setImgs([...newArray]);
                                        props.getUserDataThunk();
                                      });
                                    }
                                  }}
                                >
                                  <Avatar
                                    // src={userData?.avatar ? userData.avatar : DefaultAvatar}

                                    src={
                                      typeof file === 'string' ? file : URL.createObjectURL(file)
                                    }
                                    sx={{
                                      width: 80,
                                      height: 80,
                                      // border:
                                      //   !props.blockedUsers.find((el) => el.id === userData?.id) &&
                                      //   userData?.role === 'PREMIUM_USER'
                                      //     ? '1px solid #60A5DF'
                                      //     : '1px solid #F0F0F0',
                                      // boxShadow: props?.blockedUsers.find(
                                      //   (el) => el.id === userData?.id
                                      // )
                                      //   ? '0px 0px 2px 2px rgba(255,0,0,1)'
                                      //   : 'none',
                                      borderRadius: '70px'
                                    }}
                                    variant="square"
                                  />
                                </div>
                              ))
                            ) : (
                              <div
                                key={'image'}
                                style={
                                  userData && userData?.role === 'PREMIUM_USER'
                                    ? {
                                        border: !props.blockedUsers.find(
                                          (el) => el.id === userData.id
                                        )
                                          ? '2px solid #60A5DF'
                                          : '2px solid red',
                                        borderRadius: '80px'
                                      }
                                    : {
                                        border: !props.blockedUsers.find(
                                          (el) => el.id === userData.id
                                        )
                                          ? '2px solid #F0F0F0'
                                          : '2px solid red',
                                        borderRadius: '80px'
                                      }
                                }
                                className={
                                  params.id === props.userData.id
                                    ? `upload-avatar ${
                                        userData?.role === 'PREMIUM_USER' && 'premiumAvatar'
                                      }`
                                    : `${userData?.role === 'PREMIUM_USER' && 'premiumAvatar'}`
                                }
                                onClick={() => {
                                  if (params.id === props.userData.id) {
                                    const btn = document.getElementById('button-file-avatar');
                                    btn.click();
                                  }
                                }}
                              >
                                {params.id === props.userData.id ? (
                                  <input
                                    // accept="image/*"
                                    accept=".jpeg,.jpg,.png"
                                    style={{ display: 'none' }}
                                    id="button-file-avatar"
                                    onChange={(e) => {
                                      e.preventDefault();
                                      dispatch(
                                        setIsOpenImageCropModal({
                                          isOpen: true,
                                          file: e?.target?.files[0],
                                          setter: (file) => {
                                            apiAvatar
                                              .sendRequest({ media: [file] }, true)
                                              .then((res) => {
                                                const newArray = [...imgs];
                                                newArray.push(file);
                                                setImgs([...newArray]);
                                                props.getUserDataThunk();
                                              })
                                              .catch((error) => {
                                                if (
                                                  error ===
                                                  'The selected photo is not in a supported format'
                                                ) {
                                                  enqueueSnackbar(
                                                    'Не вірний формат фото, використовуйте (.jpg .jpeg .png)',
                                                    { variant: 'error' }
                                                  );
                                                }
                                              });
                                          }
                                        })
                                      );
                                      e.target.value = '';
                                    }}
                                    type="file"
                                  />
                                ) : null}

                                <label
                                  htmlFor="button-file-avatar"
                                  style={{
                                    width: '80px',
                                    height: '80px',
                                    cursor:
                                      params?.id === props?.userData?.id ? 'pointer' : 'default'
                                    // zIndex:'99'
                                  }}
                                >
                                  <Avatar
                                    src={DefaultAvatar}
                                    sx={{
                                      width: 80,
                                      height: 80,
                                      borderRadius: '80px'
                                      // border: !props.blockedUsers.find((el) => el.id === userData?.id)
                                      //   ? '2px solid #F0F0F0'
                                      //   : '2px solid #F0F0F0'
                                    }}
                                    variant="square"
                                  />
                                </label>
                              </div>
                            )}
                          </div>
                          <Typography
                            component="p"
                            fontSize={16}
                            lineHeight="16px"
                            sx={{
                              wordBreak: 'break-all',
                              color: '#7C7C7C',
                              fontFamily: 'FixelText-Regular'
                            }}
                          >
                            {`@${userData?.nickname}`}
                          </Typography>
                          {/*menu*/}
                          {params.id === props.userData.id ? (
                            <div
                              style={{
                                color: '#60A5DF',
                                fontSize: '24px',
                                cursor: 'pointer',
                                marginLeft: 'auto',
                                position: 'absolute',
                                top: -5,
                                right: 0
                              }}
                            >
                              <Tooltip title="Редагувати дані">
                                <EditOutlinedIcon
                                  onClick={() => {
                                    dispatch(setIsOpenUserEditModal(true));
                                  }}
                                  style={{
                                    color: '#60A5DF',
                                    right: '-30px',
                                    top: '-1px',
                                    fontSize: '26px',
                                    cursor: 'pointer',
                                    // border: '1px solid black',
                                    borderRadius: '0',
                                    boxShadow: 'none'
                                  }}
                                />
                              </Tooltip>
                            </div>
                          ) : (
                            <div
                              id="positioned-button"
                              style={{
                                fontSize: '24px',
                                cursor: 'pointer',
                                marginLeft: 'auto',
                                position: 'absolute',
                                top: 10,
                                right: 0,
                                boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                width: '40px',
                                height: '40px',
                                borderRadius: '80px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 101,
                                background: '#fff'
                              }}
                            >
                              <MoreHoriz onClick={(event) => handleClick(event)} />
                              <Menu
                                anchorEl={anchorEl}
                                id="action-menu"
                                open={open}
                                onClose={handleClose}
                                PaperProps={{
                                  elevation: 0,
                                  sx: {
                                    overflow: 'hidden',

                                    borderRadius: '8px',
                                    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                                    paddingTop: '8px',
                                    paddingLeft: '8px',
                                    paddingRight: '8px',
                                    width: '310px',
                                    mt: 1
                                  }
                                }}
                                autoFocus={false}
                                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                              >
                                {!props?.blockedUsers.find((user) => user?.id === userData?.id) && (
                                  <MenuItem
                                    sx={{
                                      fontWeight: '500',
                                      padding: '4px 12px',
                                      borderRadius: '4px',
                                      ':hover': {
                                        backgroundColor: '#E2F2FF'
                                      },
                                      mb: { xs: 0, sm: 2 }
                                    }}
                                    onClick={() => {
                                      dispatch(
                                        setIsOpenResendingModal({
                                          isOpen: true,
                                          id: params.id,
                                          type: 'user'
                                        })
                                      );
                                      handleClose();
                                    }}
                                  >
                                    <Typography
                                      component="p"
                                      fontSize={16}
                                      lineHeight="20px"
                                      fontWeight={400}
                                    >
                                      Відправити профіль в повідомленні
                                    </Typography>
                                  </MenuItem>
                                )}

                                {props.subscriptions.find(
                                  (subscription) => subscription.id === userData.id
                                ) ? (
                                  <MenuItem
                                    sx={{
                                      fontWeight: '500',
                                      padding: '4px 12px',
                                      borderRadius: '4px',
                                      ':hover': {
                                        backgroundColor: '#E2F2FF'
                                      },
                                      mb: { xs: 0, sm: 2 }
                                    }}
                                    onClick={() => {
                                      if (!mutedUsers.find((el) => el === userData?.id)) {
                                        apiMuteUser
                                          .postDataQuery({ mutedUserId: userData?.id })
                                          .then((res) => {
                                            props.getMutedUsersThunk();
                                          });
                                      } else {
                                        apiUnmuteUser
                                          .deleteItemQuery({ mutedUserId: userData?.id })
                                          .then((res) => {
                                            props.getMutedUsersThunk();
                                          });
                                      }
                                    }}
                                  >
                                    <Typography
                                      component="p"
                                      fontSize={16}
                                      lineHeight="20px"
                                      fontWeight={400}
                                    >
                                      {!mutedUsers.find((el) => el === userData?.id)
                                        ? ' Вимкнути сповіщення'
                                        : ' Увімкнути сповіщення'}
                                    </Typography>
                                  </MenuItem>
                                ) : null}
                                <MenuItem
                                  sx={{
                                    fontWeight: '500',
                                    padding: '4px 12px',
                                    borderRadius: '4px',

                                    ':hover': { backgroundColor: '#FFE5E5' },

                                    fontFamily: 'FixelText-Medium',

                                    color: '#1b1b1b',
                                    mb: { xs: 0, sm: 2 }
                                  }}
                                  onClick={() => {
                                    dispatch(
                                      setIsOpenComplainModal({
                                        isOpen: true,
                                        func: sendComplaint
                                      })
                                    );
                                    handleClose();
                                  }}
                                >
                                  <Typography
                                    component="p"
                                    fontSize={16}
                                    lineHeight="20px"
                                    fontWeight={400}
                                  >
                                    Поскаржитись
                                  </Typography>
                                </MenuItem>
                                <MenuItem
                                  sx={{
                                    fontWeight: '500',
                                    padding: '4px 12px',
                                    borderRadius: '4px',
                                    ':hover': {
                                      backgroundColor: !props.blockedUsers.find(
                                        (el) => el.id === userData.id
                                      )
                                        ? '#FFE5E5'
                                        : '#E2F2FF',
                                      color: !props.blockedUsers.find((el) => el.id === userData.id)
                                        ? '#F64D36'
                                        : '#1B1B1B'
                                    },
                                    mb: { xs: 0, sm: 1 }
                                  }}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    if (!props.blockedUsers.find((el) => el.id === userData.id)) {
                                      apiBU
                                        .updateDataQueryPost({ blockedUserId: userData.id })
                                        .then((res) => {
                                          handleClose();
                                          props.getBlockedUsersThunk();
                                          props.getUserSubscribersThunk(props.userData?.id);
                                          props.getUserSubscriptionsThunk(props.userData?.id);
                                          userDataSetter();
                                        });
                                    } else {
                                      apiBU
                                        .deleteItemQuery({ blockedUserId: userData.id })
                                        .then((res) => {
                                          handleClose();
                                          props.getBlockedUsersThunk();
                                          props.getUserSubscribersThunk(props.userData?.id);
                                          props.getUserSubscriptionsThunk(props.userData?.id);
                                        });
                                    }
                                  }}
                                >
                                  <Typography
                                    component="p"
                                    fontSize={16}
                                    lineHeight="20px"
                                    fontWeight={400}
                                  >
                                    {!props.blockedUsers.find((el) => el.id === userData.id)
                                      ? 'Заблокувати'
                                      : 'Розблокувати'}
                                  </Typography>
                                </MenuItem>
                              </Menu>
                            </div>
                          )}

                          <UserEditModal data={userData} isOpenModal={isOpenUserEditModal} />
                        </Grid>
                        <Grid xs={12} item>
                          <Stack
                            sx={{
                              width: '100%',
                              position: 'relative'
                            }}
                          >
                            {userData?.name && userData?.surname && (
                              <>
                                <Typography
                                  fontSize={20}
                                  lineHeight="30px"
                                  fontWeight={400}
                                  sx={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center'
                                  }}
                                >
                                  {`${userData?.name}`}
                                </Typography>
                                <Typography
                                  fontSize={20}
                                  lineHeight="30px"
                                  fontWeight={400}
                                  sx={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center'
                                  }}
                                >
                                  {`${userData?.surname}`}
                                </Typography>
                              </>
                            )}
                            {userData && userData?.role === 'PREMIUM_USER' && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  mt: 1,
                                  mb: 1
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'FixelText-Medium !important',
                                    fontSize: '12px',
                                    p: '3px 6px',
                                    backgroundColor: '#60A5DF',
                                    borderRadius: '5px',
                                    color: 'white'
                                  }}
                                >
                                  Преміум
                                </Typography>
                              </Box>
                            )}
                            {userData?.city &&
                              userData?.city.length !== 0 &&
                              userData?.country &&
                              userData?.country.length !== 0 &&
                              userData?.region &&
                              userData?.region.length !== 0 && (
                                <Typography
                                  sx={{
                                    mt: '14px',
                                    color: '#7C7C7C',
                                    textAlign: 'center'
                                  }}
                                  fontSize={16}
                                  lineHeight="20px"
                                  fontWeight={400}
                                >
                                  {`${userData?.city ? userData?.city : ''}${
                                    userData?.city &&
                                    userData?.city.length !== 0 &&
                                    userData?.region &&
                                    userData?.region.length !== 0
                                      ? ', '
                                      : ''
                                  }${userData?.region ? `${userData.region} обл.` : ''}${
                                    userData?.city &&
                                    userData?.city.length !== 0 &&
                                    userData?.country &&
                                    userData?.country.length !== 0
                                      ? ', '
                                      : ''
                                  }${userData?.country ? userData.country : ''}`}
                                </Typography>
                              )}
                            {userData?.number &&
                              userData?.number.length === 13 &&
                              userData?.number !== '+380' && (
                                <Typography
                                  sx={{
                                    mt: '14px',
                                    color: '#7C7C7C',
                                    textAlign: 'center'
                                  }}
                                  fontSize={16}
                                  lineHeight="20px"
                                  fontWeight={400}
                                >
                                  {`${userData.number}`}
                                </Typography>
                              )}
                          </Stack>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          flexDirection="row"
                          display="flex"
                          justifyContent="space-between"
                          sx={{
                            paddingTop: '10px',
                            marginTop: '15px',
                            paddingLeft: '0px !important'
                          }}
                        >
                          <Box
                            sx={{
                              width: '100%',
                              display: 'flex',
                              justifyContent: 'center'
                            }}
                          >
                            <Typography
                              onClick={() => dispatch(setIsOpenUserContactsModal(true))}
                              variant="body"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                backgroundColor: '#E2F2FF',
                                p: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontFamily: 'FixelText-Medium !important',
                                marginRight: '10px',
                                height: '36px',
                                color: '#60A5DF',
                                ':hover': {
                                  border: '2px solid #60A5DF',
                                  backgroundColor: 'white'
                                }
                              }}
                            >{`Контакти ( ${
                              params.id !== props.userData.id
                                ? userSubscriptions.length
                                : props.subscriptions.length
                            } )`}</Typography>
                            <Typography
                              onClick={() => dispatch(setIsOpenUserReadersModal(true))}
                              variant="body"
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                backgroundColor: '#E2F2FF',
                                p: '6px 12px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontFamily: 'FixelText-Medium !important',
                                color: '#60A5DF',
                                height: '36px',
                                ':hover': {
                                  border: '2px solid #60A5DF',
                                  backgroundColor: 'white'
                                }
                              }}
                            >{`Підписники ( ${
                              params.id !== props.userData.id
                                ? userSubscribers.length
                                : props.subscribers.length
                            } )`}</Typography>
                          </Box>
                        </Grid>
                        {isOpenUserContactsModal && (
                          <UserContactsModal
                            isSendDataRequest={isSendDataRequest}
                            setIsSendDataRequest={setIsSendDataRequest}
                            sendingData={{ type: 'user', id: params.id }}
                            nickname={userData.nickname}
                            isOpenModal={isOpenUserContactsModal}
                            data={
                              params.id !== props.userData.id
                                ? userSubscriptions
                                : props.subscriptions
                            }
                            setter={userDataSetter}
                            getUserSubscriptionsThunk={props.getUserSubscriptionsThunk}
                          />
                        )}
                        {isOpenUserReadersModal && (
                          <UserReadersModal
                            nickname={userData.nickname}
                            isOpenModal={isOpenUserReadersModal}
                            data={
                              params.id !== props.userData.id ? userSubscribers : props.subscribers
                            }
                          />
                        )}

                        {userData?.description && userData?.description.length !== 0 && (
                          <Grid item xs={12} sx={{ pt: '10px !important' }}>
                            <Typography
                              sx={{
                                paddingLeft: '0px',
                                mt: '10px',
                                display: '-webkit-box',
                                textAlign: 'center',
                                wordBreak: 'break-word'
                              }}
                              fontSize={16}
                              lineHeight="20px"
                              fontWeight={400}
                            >
                              {`${userData.description}`}
                            </Typography>
                          </Grid>
                        )}
                        {params?.id !== props.userData?.id && (
                          <Grid
                            item
                            xs={12}
                            flexDirection="column"
                            display="flex"
                            justifyContent="space-between"
                            sx={{ mt: 1.5 }}
                          >
                            <LetsGoBtn
                              colorScheme="white"
                              disabled={props.blockedUsers.find((user) => user.id === userData?.id)}
                              onClick={() => {
                                apiChats
                                  .postDataQuery({
                                    userId: props.userData.id,
                                    recipientId: params.id
                                  })
                                  .then((res) => {
                                    navigate(`/${props.language}/messages`);
                                  })
                                  .catch((error) => {
                                    if (
                                      error?.message.includes('There is a chat between these users')
                                    ) {
                                      const id = `${error.message.slice(
                                        error.message.indexOf('[') + 1,
                                        error.message.length - 1
                                      )}`;

                                      navigate(`/${props.language}/messages?chatId=${id}`);
                                    }
                                  });
                              }}
                              text="Написати повідомлення"
                            />
                            <LetsGoBtn
                              colorScheme={
                                props.subscriptions.find(
                                  (subscription) => subscription.id === userData.id
                                )
                                  ? 'red'
                                  : 'blue'
                              }
                              disabled={props.blockedUsers.find((user) => user.id === userData?.id)}
                              text={
                                props.subscriptions.find(
                                  (subscription) => subscription.id === userData.id
                                )
                                  ? 'Видалити з контактів'
                                  : 'Додати до контактів'
                              }
                              onClick={() => {
                                if (
                                  props.subscriptions.find(
                                    (subscription) => subscription.id === userData.id
                                  )
                                ) {
                                  apiUnSubscribe
                                    .deleteItemQuery({ subscriptionId: userData.id })
                                    .then((res) => {
                                      handleClose();
                                      userDataSetter();

                                      props.getUserSubscriptionsThunk(props.userData.id);
                                    });
                                } else {
                                  apiSubscribe
                                    .updateDataQuery({ subscriptionId: userData.id })
                                    .then((res) => {
                                      userDataSetter();
                                      props.getUserSubscriptionsThunk(props.userData.id);
                                    });
                                }
                              }}
                              margin="8px 0px"
                            />
                          </Grid>
                        )}
                      </>
                    ) : (
                      <Spinner />
                    )}
                  </Grid>
                </Paper>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                lg={12}
                sx={params.id !== props.userData.id ? { display: 'none' } : {}}
              >
                <Paper
                  elevation={0}
                  sx={
                    userData && userData?.role !== 'PREMIUM_USER'
                      ? {
                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                          borderRadius: '9px',
                          padding: '16px',
                          marginBottom: { xs: '0px', sm: '50px', lg: '0px' },
                          width: isLoadingUserData ? '340px !important' : 'unset',
                          minHeight: isLoadingUserData ? '340px' : 'unset',
                          display: isLoadingUserData ? 'flex' : 'block',
                          alignItems: isLoadingUserData ? 'center' : 'unset',
                          justifyContent: isLoadingUserData ? 'center' : 'unset',
                          maxWidth: '340px',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                      : {
                          boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
                          borderRadius: '8px',
                          padding: '16px',
                          marginBottom: { xs: '25px', sm: '20px', lg: '100px' },
                          width: isLoadingUserData ? '340px !important' : 'unset',
                          minHeight: isLoadingUserData ? '340px' : 'unset',
                          display: isLoadingUserData ? 'flex' : 'block',
                          alignItems: isLoadingUserData ? 'center' : 'unset',
                          justifyContent: isLoadingUserData ? 'center' : 'unset',
                          position: 'relative',
                          maxWidth: '340px',
                          marginLeft: 'auto',
                          marginRight: 'auto'
                        }
                  }
                >
                  <Typography
                    onClick={() => navigate(`/ua/tariffs`)}
                    fontSize={16}
                    sx={{
                      fontFamily: 'FixelText-Regular',
                      cursor: 'pointer',
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      mb: '16px',
                      letterSpacing: '0.48px',
                      ':hover': { color: '#efc938' }
                    }}
                  >
                    Преміум
                    <Star sx={{ fontSize: '18px', color: '#60A5DF' }} />
                  </Typography>
                  <Typography
                    onClick={() => navigate(`/ua/saved?type=posts`)}
                    fontSize={16}
                    sx={{
                      fontFamily: 'FixelText-Regular',
                      cursor: 'pointer',
                      textAlign: 'center',
                      mb: '16px',
                      letterSpacing: '0.48px',
                      ':hover': { color: '#efc938' }
                    }}
                  >
                    Збережені
                  </Typography>
                  <Typography
                    onClick={() => navigate(`/ua/account-settings`)}
                    fontSize={16}
                    sx={{
                      fontFamily: 'FixelText-Regular',
                      cursor: 'pointer',
                      textAlign: 'center',
                      mb: '16px',
                      letterSpacing: '0.48px',
                      ':hover': { color: '#efc938' }
                    }}
                  >
                    Налаштування
                  </Typography>
                  <Typography
                    onClick={() => {
                      localStorage.removeItem('accessToken');
                      localStorage.removeItem('refreshToken');
                      localStorage.removeItem('feedbackModal');
                      dispatch(resetState());
                      navigate(`/${props.language}`);
                    }}
                    fontSize={16}
                    sx={{
                      fontFamily: 'FixelText-Regular',
                      cursor: 'pointer',
                      textAlign: 'center',
                      color: '#F64D36',
                      letterSpacing: '0.48px',
                      ':hover': { fontFamily: 'FixelText-Semibold' }
                    }}
                  >
                    Вихід
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={9}
            sx={{
              mt: { xs: params.id !== props.userData.id ? 4 : 0, sm: 0 },
              paddingBottom: '80px',
              paddingTop: '0px !important',
              pl: { xs: '0px !important', sm: '0px !important', md: '30px !important' }
            }}
          >
            <BigSwitcher
              bools={bools}
              isDisabled={isLoading}
              textOne="Пости"
              textTwo="Товари"
              handleToggle={(isOnOne, isOnTwo) => {
                setIsLoadiang(true);
                // setContentSwitched(!contentSwitched);
                // setBools([isOnOne, isOnTwo]);
                setStartWith(0);
                const switchToOne = () => {
                  searchParams.set('type', 'posts');
                  setSearchParams(searchParams);
                  setContentSwitched(false);
                  setContent([]);
                  clearTimeout(switchToOne);
                };

                if (isOnOne) {
                  setTimeout(switchToOne, [500]);
                } else {
                  searchParams.set('type', 'services');
                  setSearchParams(searchParams);
                  setContentSwitched(true);
                  setContent([]);
                }
                // if (!contentSwitched) {
                //   apiServices
                //     .getItemById(params.id)
                //     .then((res) => {
                //       setContent(res.result);
                //       setIsLoadiang(false);
                //     })
                //     .catch((error) => {
                //       console.error(error);
                //       setIsLoadiang(false);
                //     });
                // } else {
                //   apiPosts
                //     .getItemById(params.id)
                //     .then((res) => {
                //       setContent(res.result);
                //       setIsLoadiang(false);
                //     })
                //     .catch((error) => {
                //       console.error(error);
                //       setIsLoadiang(false);
                //     });
                // }
              }}
            />
            <ToTopBtn
              to="topUserPage"
              visible={pageScroll > 500}
              sx={{ position: 'fixed', right: '8px !important', bottom: '0' }}
              icon={<ArrowUpwardIcon sx={{ fontSize: '22px' }} />}
            />
            {content.length === 0 ? (
              <>
                {isLoading ? (
                  <Spinner />
                ) : (
                  <Stack spacing={5} alignItems="center">
                    {!contentSwitched ? (
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h3" textAlign="center">
                          Постів ще немає
                        </Typography>
                        {params.id === props.userData.id ? (
                          <Typography textAlign="center" sx={{ maxWidth: '640px' }}>
                            Віримо в тебе. Створи перший пост тицьнувши на велику блакитну кнопку. А
                            якщо немає ідей - завжди є котики. Котиків люблять всі.
                          </Typography>
                        ) : (
                          <Typography textAlign="center" sx={{ maxWidth: '640px' }}>
                            У цього користувача поки що немає постів. Радимо заглянути сюди пізніше.
                          </Typography>
                        )}

                        {params.id === props.userData.id ? (
                          <LetsGoBtn2
                            padding="12.5px 42.5px "
                            text={`Додати пост`}
                            usedIcon={<AddCircle sx={{ mr: 1 }} />}
                            width="220px"
                            icon={true}
                            margin="10px auto"
                            onClick={() => {
                              dispatch(
                                setIsOpenPostModal({
                                  isOpen: true,
                                  func: dataSetter,
                                  data: null
                                })
                              );
                              // setIsCreatePost(true);
                            }}
                          />
                        ) : (
                          <LetsGoBtn2
                            padding="12.5px 42.5px "
                            text={'Перейти на стрічку'}
                            width="220px"
                            margin="10px auto"
                            onClick={() => {
                              navigate(`/${props.language}/ribbon`);
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h3" textAlign="center">
                          Товарів ще немає
                        </Typography>
                        {params.id === props.userData.id ? (
                          <Typography textAlign="center" sx={{ maxWidth: '640px' }}>
                            Покажи свій товар світу – твій покупець не змусить себе чекати!
                          </Typography>
                        ) : (
                          <Typography textAlign="center" sx={{ maxWidth: '640px' }}>
                            У цього користувача поки що немає товарів. Радимо заглянути сюди
                            пізніше.
                          </Typography>
                        )}

                        {params.id === props.userData.id ? (
                          <LetsGoBtn2
                            icon={true}
                            usedIcon={<AddCircle sx={{ mr: 1 }} />}
                            padding="12.5px 42.5px "
                            width={content.length === 0 ? '230px' : '160px'}
                            margin="10px auto"
                            text={`Додати товар`}
                            onClick={() =>
                              dispatch(
                                setIsOpenServiceModal({
                                  isOpen: true,
                                  data: null,
                                  setter: dataSetter
                                })
                              )
                            }
                          />
                        ) : (
                          <LetsGoBtn2
                            padding="12.5px 42.5px "
                            text={'Перейти на стрічку'}
                            width="220px"
                            margin="10px auto"
                            onClick={() => {
                              navigate(`/${props.language}/ribbon`);
                            }}
                          />
                        )}
                      </div>
                    )}
                  </Stack>
                )}
              </>
            ) : (
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'end', mb: 2 }}
                >
                  {params?.id === props.userData?.id &&
                  props.userData?.role === 'PREMIUM_USER' &&
                  existsInactive ? (
                    <Typography
                      sx={{
                        alignSelf: 'center',
                        fontFamily: 'FixelText-Regular',
                        textDecoration: 'underline',
                        marginRight: '20px',
                        cursor: 'pointer',
                        fontSize: '16px',
                        ':hover': {
                          color: 'rgb(96, 165, 223)'
                        }
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        apiActivateServices
                          .updateDataQuery({ isActive: true })
                          .then((res) => dataSetter(true))
                          .catch((error) => {
                            console.error(error);
                            enqueueSnackbar('Товари не активовано!', { variant: 'error' });
                          });
                      }}
                    >
                      Активувати всі товари
                    </Typography>
                  ) : null}
                  {params.id === props.userData.id && (
                    <LetsGoBtn2
                      icon={content.length !== 0}
                      usedIcon={<AddCircle sx={{ mr: '10px' }} />}
                      padding="12.5px 42.5px "
                      width={content.length === 0 ? '230px' : '160px'}
                      margin="10px auto"
                      text={`${!contentSwitched ? 'Додати пост' : 'Додати товар'}`}
                      onClick={() => {
                        if (contentSwitched) {
                          dispatch(
                            setIsOpenServiceModal({
                              isOpen: true,
                              setter: dataSetter,
                              data: null
                            })
                          );
                        } else {
                          dispatch(
                            setIsOpenPostModal({
                              isOpen: true,
                              setter: dataSetter,
                              data: null
                            })
                          );
                          // setIsCreatePost(true);
                        }
                      }}
                    />
                  )}
                </Grid>
                {content.map((el, index) => {
                  if (contentSwitched) {
                    return (
                      <Grid
                        key={`service${index}`}
                        item
                        xs={12}
                        sm={4}
                        lg={4}
                        sx={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <ServiceCard
                          noWidth
                          sx={{ marginBottom: '10px !important' }}
                          key={index}
                          index={index}
                          el={el}
                          dataSetter={dataSetter}
                        />
                      </Grid>
                    );
                  }
                  return (
                    <Grid
                      key={`post${index}`}
                      item
                      xs={12}
                      sx={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <PostCard
                        noWidth
                        sx={{ marginBottom: '10px !important' }}
                        key={index}
                        index={index}
                        el={el}
                        dataSetter={dataSetter}
                      />
                    </Grid>
                  );
                })}
                {contentMaxCount > startWith + 1 && (
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <LetsGoBtn2
                      sx={{ margin: '30px auto !important' }}
                      text={loadMore ? <Spinner type="small" /> : 'Завантажити ще'}
                      onClick={handleLoadMore}
                    />
                  </Grid>
                )}
              </Grid>
            )}
            {/* {isOpenPostModal && isCreatePost && (
              <PostModal setter={dataSetter} isOpenModal={isOpenPostModal} />
            )} */}
          </Grid>
        </Grid>
      </Stack>
    </Page>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    subscribers: state.global.userSubscribers,
    subscriptions: state.global.userSubscriptions,
    blockedUsers: state.global.blockedUsers
  };
};
export default connect(mapStateToProps, {
  getUserSubscriptionsThunk: base.getUserSubscriptionsThunk,
  getUserSubscribersThunk: base.getUserSubscribersThunk,
  getBlockedUsersThunk: base.getBlockedUsersThunk,
  getMutedUsersThunk: base.getMutedUsersThunk,
  getUserDataThunk: base.getUserDataThunk
})(UserPage);
